import * as Types from './types';

const getFeatures = postingId => ({
  type: Types.GET_FEATURES,
  meta: {
    async: true,
    blocking: false,
    api: 'publicador',
    path: `/publicador/api/v1/postings/STEP_EXTRA/${postingId}`,
    method: 'GET'
  }
});

const changeFeatureSelection = featureId => ({
  type: Types.CHECK_FEATURE,
  payload: featureId
});

const changeInput = (inputType, inputId, value) => ({
  type: Types.CHANGE_INPUT,
  payload: { inputType, inputId, value }
});

export { getFeatures, changeFeatureSelection, changeInput };
